const retainedBackend = 'https://nwgxdrldipcuyxupaqit.supabase.co';
const heldPrefixes = [
  '/practice-team',
  '/ambulances',
  '/ambulance',
  '/pay/sponsor',
  '/admin',
];

export function isProductionReleaseContext({appEnv, hostname, reviewMode}) {
  return reviewMode === true ||
    String(appEnv || '').trim().toLowerCase() === 'production' ||
    String(hostname || '').trim().toLowerCase() === 'app.afrimed.tech';
}

// Review builds exercise public release holds on Staging. Keep the established
// Admin workspace available only on the retained Staging runtime. Individual
// routes keep their existing ProtectedRoute and invitation/callback checks.
export function isStagingAdminRoute({hostname, pathname, runtimeSource}) {
  const stagingRuntime =
    (hostname === 'staging.afrimed.tech' && runtimeSource === 'runtime-staging-override') ||
    (['localhost', '127.0.0.1'].includes(hostname) && runtimeSource === 'explicit-local-staging-ui');
  return stagingRuntime && (pathname === '/admin' || pathname.startsWith('/admin/'));
}

export function productionLaunchBoundary({appEnv, hostname, reviewMode, supabaseUrl, pathname}) {
  if (!isProductionReleaseContext({appEnv, hostname, reviewMode})) return null;
  if (String(supabaseUrl || '').replace(/\/+$/, '') !== retainedBackend) return 'configuration';
  const path = typeof pathname === 'string' ? pathname : '';
  if (heldPrefixes.some(prefix => path === prefix || path.startsWith(`${prefix}/`)) ||
      /\/preferences\/(practice-team)(\/|$)/.test(path) ||
      /\/(practice-team|prepare-sponsor-payment|sponsor-payment|sick-notes?|tests|labs)(\/|$)/.test(path)) return 'held';
  return null;
}
